// Configuration for business field specific action cards
// This allows easy addition of new business fields and their associated action cards

import { VehicleModuleIcon } from '../images/Icons/ModuleActionIcons';

export const businessFieldConfigs = [
    {
        businessFieldValue: 0, // VehicleDealership
        titleKey: 'VehicleManagement',
        icon: VehicleModuleIcon,
        accent: 'blue',
        directClick: true,
        navigationFunctionKey: 'viewVehicleManagement', // Key to identify which navigation function to use
        items: [
            // Vehicle management specific items can be added here
            // For now, we'll use the direct click functionality
        ]
    },
    {
        businessFieldValue: 2, // Garage (מוסך רכבים)
        titleKey: 'Garage',
        icon: VehicleModuleIcon,
        accent: 'blue',
        directClick: true,
        navigationFunctionKey: 'viewGarageWorkDiary',
        items: []
    },
    // {
    //     businessFieldValue: null, // Audit Reports - available for all business fields
    //     titleKey: 'AuditReports',
    //     icon: ReportsModuleIcon,
    //     accent: 'blue',
    //     directClick: true,
    //     navigationFunctionKey: 'viewAuditReports',
    //     items: []
    // },
    // Add more business field configurations here as needed
];

export default businessFieldConfigs;
